import b from 'b_';
import cx from 'classnames';
import { MarkdownExtXContent as Markdown, Text } from 'platform-components';
import {
    withRouterPath,
    InjectedProps as WithRouterPathProps,
} from 'platform-components/src/utils/hocs/with-router-path/with-router-path';
import React from 'react';
import { useSelector } from 'react-redux';

import { isMesTeam } from 'common.components/classes/utils';
import { getCurrentClass } from 'common.components/user/selectors';

import './showcase.scss';

interface HOCProps extends WithRouterPathProps {}

interface OwnProps {
    description?: string;
    mix?: string;
}

interface Props extends OwnProps, HOCProps {}

export const LibraryTabContent = ({
    description,
    mix,
    match: {
        params: { classId: classIdFromUrl },
    },
}: Props) => {
    const classId = Number(classIdFromUrl);
    const currentClass = useSelector((state) => getCurrentClass(state, { classId }));

    if (!description) {
        return null;
    }

    const isMes = isMesTeam(currentClass);

    return (
        <div className={cx(b('showcase', { 'mes-team': isMes }), mix)}>
            <Text>
                <Markdown>{description}</Markdown>
            </Text>
        </div>
    );
};

export default React.memo(withRouterPath(LibraryTabContent));
